import { RefObject, useMemo } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { TSTTable } from "@impero-com/ui";
import {
    createColumnHelper,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";

import { ControlProgramTagView } from "api/generated/model";

interface ControlProgramTagsSubTableProps {
    tags: ControlProgramTagView[];
    tableElement: RefObject<HTMLDivElement | null>;
}

export function ControlProgramTagsSubTable({
    tags,
    tableElement,
}: ControlProgramTagsSubTableProps) {
    const { t } = useTranslation();
    const subRows: ControlProgramTagView[] = tags || [];
    const subTableColumns = useMemo(() => {
        const columnHelper = createColumnHelper<ControlProgramTagView>();
        return [
            columnHelper.accessor("name", {
                header: t("Tags"),
                cell: (info) => info.getValue(),
            }),
        ];
    }, [t]);

    const subTable = useReactTable({
        data: subRows,
        columns: subTableColumns,
        initialState: {
            sorting: [
                {
                    id: "name",
                    desc: false,
                },
            ],
        },
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <TSTTable
            tableRef={tableElement}
            table={subTable}
            noResultsFallback={t("NoResults")}
            noSourceRowsFallback={t("NoResults")}
        />
    );
}
